import { Form, Input } from "reactstrap";
import { SVG } from "../../../AbstractElements";
import { SearchAnything } from "../../../utils/Constant";
import { ChangeEvent, useEffect, useState } from "react";
import { MenuItem, SearchSuggestionItem } from "../../../Type/Layout/Sidebar";
import { MenuList } from "../../../Data/Layout/Sidebar";
import ResponsiveSearchList from "./ResponsiveSearchList";
import { getLinkItemsArray } from "src/ReduxToolkit/Reducers/BookmarkHeaderSlice";
import { useDispatch } from "react-redux";

const SearchInput = () => {
  const [arr, setArr] = useState<SearchSuggestionItem[]>([]);
  const [searchedWord, setSearchedWord] = useState<string>("");
  const [searchedArray, setSearchedArray] = useState<SearchSuggestionItem[]>([]);
  const dispatch = useDispatch();
  useEffect(() => {
    const suggestionArray: SearchSuggestionItem[] = [];
    let num = 0;
    const getAllLink = (item: MenuItem, icon: string | undefined) => {
      if (item.children) {
        item.children.forEach((ele) => {
          getAllLink(ele, icon);
        });
      } else {
        num = num + 1;
        suggestionArray.push({ icon: icon, title: item.title, path: item.path ? item.path : '' , bookmarked: false, id: num });
      }
    };
    MenuList?.forEach((item) => {
      item.Items?.forEach((child) => {
        getAllLink(child, child.icon);
      });
    });
    setArr(suggestionArray);
    dispatch(getLinkItemsArray(suggestionArray));
  }, [dispatch]);


  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
  if (!searchedWord) setSearchedWord("");
    setSearchedWord(e.target.value);
    const result = arr.filter((item) =>item.title?.toLowerCase().includes(e.target.value.toLowerCase()));
    setSearchedArray(result);
  };
  return (
    <Form className="col-auto form-inline search-full">
      <div className="form-group">
        <div className="Typeahead Typeahead--twitterUsers">
          <div className="u-posRelative">
            <Input type="text" placeholder={SearchAnything} onChange={(e) => handleSearch(e)} value={searchedWord} className="demo-input Typeahead-input form-control-plaintext w-100"/>
            <SVG className="search-bg svg-color" iconId="Search" />
          </div>
          <div className={`Typeahead-menu custom-scrollbar ${searchedWord.length ? "is-open" : ""}`}> 
            <ResponsiveSearchList searchedArray={searchedArray} setSearchedWord={setSearchedWord}/>
          </div>
        </div>
      </div>
    </Form>
  );
};

export default SearchInput;
